import { AxiosRequestConfig } from 'axios'
import API from '../apiCreate'
import { getParams } from '../getParams'
import { EmptyResponse, PaginationParam } from '../types/base.types'
import {
  RequestCreateCertificateBackground,
  RequestCreateCertificateTemplate,
  RequestUpdateCertificateTemplate,
  ResponseCertificate,
  ResponseCertificateBackgrounds,
  ResponseCertificateTemplate,
  ResponseCertificateTemplates,
} from '../types/certificates.types'

export const certificateApi = {
  getCertificateTemplates: (params: {
    paramsPagination: PaginationParam
    search: string | undefined
  }) =>
    API.get<ResponseCertificateTemplates>(
      `certificates/get-certificate-templates/${getParams({
        ...params,
        expand: ['background'],
      })}`,
    ),

  insertCertificateTemplate: (data: RequestCreateCertificateTemplate) =>
    API.post<ResponseCertificateTemplate>(
      'certificates/insert-certificate-template',
      data,
      // {...data, content: JSON.stringify(data.content)},
    ),
  updateCertificateTemplate: (data: RequestUpdateCertificateTemplate) =>
    API.put<ResponseCertificateTemplate>(
      'certificates/update-certificate-template',
      data,
      // {...data, content: JSON.stringify(data.content)},
    ),
  deleteCertificateTemplate: (id: number) =>
    API.delete<EmptyResponse>(
      `certificates/delete-certificate-template?id=${id}`,
    ),

  getBackgrounds: (params: {
    paramsPagination: PaginationParam
    search: string | undefined
  }) =>
    API.get<ResponseCertificateBackgrounds>(
      `certificates/get-backgrounds/${getParams(params)}`,
    ),
  uploadBackground: (
    data: RequestCreateCertificateBackground,
    config?: Omit<AxiosRequestConfig, 'headers'>,
  ) =>
    API.post<ResponseCertificateBackgrounds>(
      'certificates/upload-background',
      data,
      {
        ...config,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    ),
  deleteBackground: (id: number) =>
    API.delete<EmptyResponse>(`certificates/delete-background?id=${id}`),

  getCourseCertificateTemplate: (params: { courseId: number }) =>
    API.get<ResponseCertificateTemplate>(
      `certificates/get-course-certificate-template/${getParams({
        ...params,
        expand: ['background'],
      })}`,
    ),
  updateCourseCertificateTemplate: (params: {
    courseId: number
    certificateTemplateId: number
  }) =>
    API.post<ResponseCertificateTemplate>(
      `certificates/update-course-certificate-template/${getParams({
        ...params,
        expand: ['background'],
      })}`,
    ),

  // -------- для ученика ---------
  getCertificate: (params: {
    courseIdOrGroupId: number
    type: 'private' | 'group'
    children_id?: number
  }) =>
    API.get<ResponseCertificate>(
      `certificates/get-certificate/${getParams({
        ...params,
        expand: ['background'],
      })}`,
    ),

  // -------- для сотрудников ---------
  getCertificateForAdmin: (params: {
    studentId: number
    courseIdOrGroupId: number
    type: 'private' | 'group'
  }) =>
    API.get<ResponseCertificate>(
      `certificates/get-certificate-for-admin/${getParams({
        ...params,
        expand: ['background'],
      })}`,
    ),

  saveCertificateData: (params: {
    courseIdOrGroupId: number
    type: 'private' | 'group'
    children_id?: number
  }) =>
    API.post<EmptyResponse>(
      `certificates/save-certificate-data/`,
      params,
    ),
}
